export function collapseFadeOut(element, options) {
    return element.animate([
        {
            opacity: 1,
            transform: "scaleY(1)",
            transformOrigin: "top",
        },
        {
            opacity: 0,
            transform: "scaleY(0)",
            transformOrigin: "top",
        },
    ], options);
}
export function expandFadeIn(element, options) {
    return element.animate([
        {
            opacity: 0,
            transform: "scaleY(0)",
            transformOrigin: "top",
        },
        {
            opacity: 1,
            transform: "scaleY(1)",
            transformOrigin: "top",
        },
    ], options);
}
//# sourceMappingURL=index.js.map